export const getListId = (data) => data.map((item) => item.organizationId)

export const convertDataTableRedux = (data) => {
  const ids = getListId(data)
  const objData = {}

  const convertObj = (data) => {
    return {
      ...data,
      status: {
        activeStatusName: data?.activeStatusName,
        activeStatusId: data?.activeStatusId,
      },
    }
  }

  ids.forEach((id) => {
    objData[id] = convertObj({
      ...data.find((item) => item.organizationId === id),
    })
  })

  return objData
}
